// extracted by mini-css-extract-plugin
module.exports = {"right":"Header_right__2MHlD","select":"Header_select__3Yjgj","clinic":"Header_clinic__2Izqv"};